<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
              <CRow >
                <CCol >
                  <label> Title </label>
                  <b-input v-model="form.title" placeholder='Title' :state="validationTitle" id="feedback-user" class="mb-1"> </b-input>
                  <b-form-invalid-feedback :state="validationTitle">
                  Your title must be filled
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validationTitle">
                  Looks Good.
                  </b-form-valid-feedback>  
                </CCol>
              </CRow>
              <CRow class="mt-3">
                <CCol >
                  <label> Subtitle </label>
                  <b-input v-model="form.subtitle" placeholder='Subtitle' :state="validationURL" id="feedback-user" class="mb-1"> </b-input>
                  <b-form-invalid-feedback :state="validationURL">
                  Your URL must be filled
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validationURL">
                  Looks Good.
                  </b-form-valid-feedback>  
                </CCol>
              </CRow> 
            <hr>
              <CRow class="mt-3">
                <CCol >
                  <label> Card Image </label>
                <p style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p>
                <img v-bind:src="form.card_image" style="width:200px"/>
                <CRow>
                  <CCol>
                <b-form-file v-if="mode === 'create'" v-model="form.card_image"  plain></b-form-file>
                  </CCol>
                </CRow>
                <CButton  class="ml-3" v-if="mode === 'edit'" type="button" @click="openModalPhotoCardImage(form.id)"  variant="outline" color="info">Change Image</CButton>
                </CCol>
              </CRow>
            <hr>
              <CRow class="mt-3">
                <CCol >
                  <label> Background Image </label>
                  <p style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p>
                <img v-bind:src="form.bg_image" style="width:200px"/>
                <b-form-file v-if="mode === 'create'" v-model="form.bg_image"  plain></b-form-file>
                <CButton  class="ml-3" v-if="mode === 'edit'" type="button" @click="openModalPhotoBGImage(form.id)"  variant="outline" color="info">Change Image</CButton>
                </CCol>
              </CRow>
          </CCol> 
        </CRow>
        <template #footer>
          <CButton @click="show = false" color="danger">Cancel</CButton>
          <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
          <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Update</CButton>
        </template>
      <pre>{{ $data | json }}</pre> 
    </CModal>
    <modalphotocard></modalphotocard>
    <modalphotobg></modalphotobg>
  </form>
</template>

<script>
import EventBus from '@/eventBus';
import modalphotocard from './article_modal_photo_bgimage.vue';
import modalphotobg from './article_modal_photo_cardimage.vue';
import articlecategory from '@/services/articlecategory'


export default {
name: 'sectionmodal',
components: {
    modalphotocard,
    modalphotobg,
  },

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        title: '',
        subtitle:'',
        card_image:'',
        bg_image:'',
        get_photo:'',
        
      },
   
      
    }
  },
   computed: {
      validationTitle() {
        return this.form.title.length > 0 
      },
      validationURL() {
        return this.form.subtitle.length > 0 
      },
    

   },
  
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_ARTICLE_CATEGORY', (params) => {
      if(params.data){
        articlecategory.getArticleCategorybyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = params.data;
          self.form.title = res.data.title;
          self.form.subtitle = res.data.subtitle;
          self.form.card_image = res.data.card_image;
          self.form.bg_image = res.data.bg_image;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.title = "";
        self.form.url = "";
        self.form.subtitle = "";
        self.form.card_image = "";
        self.form.bg_image = "";
        
      }
    });
  },

  

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      let formData = new FormData();
      formData.append('title', this.form.title );
      formData.append('subtitle', this.form.subtitle );
      formData.append('bg_image', this.form.bg_image );
      formData.append('card_image', this.form.card_image );
      
      articlecategory.createArticleCategory(formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    update(id){
      let formData = new FormData();
      formData.append('title', this.form.title );
      formData.append('subtitle', this.form.subtitle );
      formData.append('bg_image', this.form.bg_image );
      formData.append('card_image', this.form.card_image );
      
      articlecategory.updateArticleCategory(id, formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BGIMAGE_ARTICLE', params)
        console.log('load modal photo')      
    },
    openModalPhotoCardImage(id){
        var params = {title: 'Update Card Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_CARDIMAGE_ARTICLE', params)
        console.log('load modal photo')      
    },
       
  }
}
</script>

<style>

</style>